//引入mockjs
const Mock = require('mockjs')
// 获取 mock.Random 对象
const Random = Mock.Random;
//使用mockjs模拟数据
Mock.mock('/api/data', (req, res) => {//当post或get请求到/api/data路由时Mock会拦截请求并返回上面的数据
    let list = [
        {
            name:'数据报表',
            route:'',
            sign:'',
            id:0,
            children:[
                {
                    name:'投放报告',
                    route:'/dataReport/tfReport',
                    sign:'tfReport',
                    id:1
                },
                {
                    name:'利润报告',
                    route:'/dataReport/profitsReport',
                    sign:'profitsReport',
                    id:2
                },
                {
                    name:'商务业绩分析',
                    route:'/dataReport/businessReport',
                    sign:'businessReport',
                    id:3
                },
                {
                    name:'运营业绩分析',
                    route:'/dataReport/operatingReport',
                    sign:'operatingReport',
                    id:4
                },
                {
                    name:'优化业绩分析',
                    route:'/dataReport/optimizeReport',
                    sign:'optimizeReport',
                    id:5
                }
            ]
        },
        {
            name:'广告主管理',
            route:'',
            sign:'',
            id:6,
            children:[
                {
                    name:'广告主管理',
                    route:'/adManagement/advertisers',
                    sign:'advertisers',
                    id:7
                },
                {
                    name:'广告产品管理',
                    route:'/adManagement/adProducts',
                    sign:'adProducts',
                    id:8
                }
            ]
        },
        {
            name:'投放管理',
            route:'',
            sign:'',
            id:9,
            children:[
                {
                    name:'投放账号',
                    route:'/tfManagement/tfAccount',
                    sign:'tfAccount',
                    id:10,
                },
                {
                    name:'投放媒体',
                    route:'/tfManagement/tfMedia',
                    sign:'tfMedia',
                    id:11
                }
            ]
        },
        {
            name:'系统管理',
            route:'',
            sign:'',
            id:12,
            children:[
                {
                    name:'角色管理',
                    route:'/system/roleManagement',
                    sign:'roleManagement',
                    id:13
                },
                {
                    name:'部门管理',
                    route:'/system/department',
                    sign:'department',
                    id:14
                },
                {
                    name:'角色管理',
                    route:'/system/userManagement',
                    sign:'userManagement',
                    id:15
                },
            ]
        }
    ]
    let user = {
        name:'齐坤'
    }
    return {
        data: {
            list:list,
            user:user
        }
    }
})
Mock.mock('/api/departmentList', (req, res) => {//当post或get请求到/api/data路由时Mock会拦截请求并返回上面的数据
    let list = [
        {
            id: 1,
            name: "部门1",
            member_total: 0,  //部门人数
            pid: 0,
            level: 1,                // 层级
            status: 1,            //1:有效 2:无效
            children: [
                {
                    id: 3,
                    name: "部门3",
                    member_total: 0,
                    pid: 1,
                    level: 2,
                    status: 1,
                    children: [
                        {
                            id: 5,
                            name: "部门5",
                            member_total: 0,
                            pid: 3,
                            level: 3,
                            status: 1,
                            children: []
                        }
                    ]
                }
            ]
        },
    ]
    return {
        data: list
    }
})


// WEBPACK FOOTER //
// ./src/mock/index.js